import React, { useEffect, useState } from "react";
import { FaTimes, FaEdit } from "react-icons/fa";

function SelectAnswers(props) {
  const [answersList, setAnswersList] = useState([]);
  const [answersSelect, setAnswersSelect] = useState([]);

  const [startValidate, setStartValidate] = useState(false);

  const [insertMode, setInsertMode] = useState([false]);
  const [nameAnswer, setNameAnswer] = useState();
  const [exists, setExists] = useState({ bool: false, value: "" });

  const deleteAnswer = (id, label) => {
    var tempLIST = answersSelect.filter(function (f) {
      return f.value !== id;
    });
    setAnswersSelect(
      answersSelect.filter(function (f) {
        return f.value !== id;
      })
    );
    var temp = answersList;
    temp.push({ value: id, label: label });
    setAnswersList(temp);

    props.setValue(
      tempLIST.map(function (a) {
        return a.value;
      })
    );
  };

  const sendNewAnswer = (value) => {
    setNameAnswer(" ");
    setStartValidate(true);
    var validatePassed = true;
    if (!nameAnswer) validatePassed = false;
    if (validatePassed) {
      var temp = answersSelect;
      temp.push({ value: nameAnswer, label: nameAnswer });
      setAnswersSelect(temp);
      props.setValue(
        answersSelect.map(function (a) {
          return a.value;
        })
      );
      setInsertMode(true);
    }
    if (value !== null) {
      setExists({ bool: false, value: "" });
    }
  };

  useEffect(() => {
    if (props.editMode) {
      var temp = answersSelect;

      temp = props.value.map((x) => {
        return { value: x, label: x };
      });

      setAnswersSelect(temp);
    }
  }, [props.value]);

  return (
    <div className="row mt-3 border px-2 py-4 " style={{ minHeight: "250px" }}>
      <div className="col-9 mb-2">
        <b>Risposte</b>
      </div>
      <div className="col-3 mb-2 text-right">
        <button
          className="btn btn-primary  "
          disabled={props.disabled ? "" : "disabled"}
          onClick={() => {
            setInsertMode(!insertMode);
            setNameAnswer(" ");
          }}
        >
          {insertMode ? (
            <>
              <>Nuova Risposta</>
            </>
          ) : (
            <>Annulla</>
          )}
        </button>
      </div>
      {insertMode ? (
        <>
          <div
            className="col-12 border  rounded"
            style={{ height: "150px", overflow: "auto", padding: "25px" }}
          >
            {" "}
            <div className="it-list-wrapper">
              <ul className="it-list pt-2">
                {answersSelect &&
                  answersSelect.map((x, index) => (
                    <li key={index} className="py-2">
                      <div className=" row px-2 py-2">
                        <div className="col-10">
                          {" "}
                          <b>{x.label}</b>{" "}
                          <a
                            href="/#"
                            onClick={() => {
                              setInsertMode(!insertMode);
                              setNameAnswer(x.value);
                              deleteAnswer(x.value, x.label);
                            }}
                          >
                            <FaEdit style={{ marginBottom: "4px" }} />
                          </a>
                          <a
                            href="/#"
                            onClick={() => {
                              deleteAnswer(x.value, x.label);
                            }}
                          >
                            <FaTimes
                              style={{ marginBottom: "4px", color: "red" }}
                            />
                          </a>
                        </div>
                      </div>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </>
      ) : (
        <>
          {" "}
          <div className="col-12">
            <div className="row">
              <div className="col-10">
                <div className="row">
                  <div className="col-12">
                    <input
                      id="name"
                      name="name"
                      placeholder="Inserisci la risposta"
                      onChange={(e) => setNameAnswer(e.target.value)}
                      value={nameAnswer}
                      className="form-control"
                      {...(startValidate &&
                        !nameAnswer && {
                          infoText: "Il campo non può essere vuoto!",
                        })}
                      {...(startValidate &&
                        !nameAnswer && { className: "text-danger" })}
                    />
                  </div>
                </div>
              </div>
              <div className="col-2 text-right ">
                <button
                  onClick={() => {
                    if (exists.bool) {
                      sendNewAnswer(exists.value);
                    } else {
                      sendNewAnswer(null);
                    }
                  }}
                  className="btn btn-primary"
                >
                  INSERISCI
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default SelectAnswers;
